
import React from "react";
import {Col, Container, Row} from "react-bootstrap";



function OrderSummaryView(params) {
    const summary = params.summaryData != null  ? params.summaryData : {};
    return <div className="press-grid">
        <Container>
            <Row>
                <Col>Placed</Col>
                <Col>Filled </Col>
                <Col>B/S/C</Col>
                <Col>PnL</Col>
                <Col>Ticks</Col>
            </Row>
            <Row>
                <Col>{summary.totalOrders}</Col>
                <Col>{summary.executedTrades}</Col>
                <Col>{summary.buyOrdersFilled}/{summary.sellOrdersFilled}/{summary.cancelledTrades}</Col>
                <Col>{summary.totalPnL} </Col>
                <Col>{summary.dataTicks}</Col>
            </Row>
        </Container>
    </div>;
}
export {OrderSummaryView}
